<template>
    <div class="list-container">
        <h2>Manage Practitioners</h2>
        <button class="btn btn-sm add-btn" @click="$router.push({ name: 'PractitionerAdd' })">
            ➕ Add Practitioner
        </button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <table class="table table-bordered w-100" v-else>
            <thead class="table-light">
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Signature</th>
                    <th>Status</th>
                    <th style="width: 180px;">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="practitioner in practitioners" :key="practitioner.id"
                    :class="{ 'bg-disabled': !practitioner.user.is_active }">
                    <td>{{ practitioner.user.name }}</td>
                    <td>{{ practitioner.user.email }}</td>
                    <td>
                        <img v-if="practitioner.signature_base64" :src="practitioner.signature_base64" alt="Signature"
                            height="50" />
                        <span v-else>-</span>
                    </td>
                    <td>{{ practitioner.user.is_active ? 'Active' : 'Disabled' }}</td>
                    <td>
                        <button class="btn btn-sm edit-btn"
                            @click="$router.push({ name: 'PractitionerEdit', params: { id: practitioner.id } })">✏️
                            Edit</button>
                        <button class="btn btn-sm mt-1"
                            :class="practitioner.user.is_active ? 'btn-danger' : 'btn-success'"
                            @click="togglePractitionerStatus(practitioner.id)">
                            {{ practitioner.user.is_active ? 'Disable' : 'Enable' }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            practitioners: [],
            loading: false,
        };
    },
    methods: {
        async fetchPractitioners() {
            this.loading = true;
            try {
                const res = await this.$api.get("/practitioners");
                this.practitioners = res.data;
            } catch (error) {
                console.error("Error fetching practitioners:", error);
            } finally {
                this.loading = false;
            }
        },
        async togglePractitionerStatus(id) {
            if (!confirm("Are you sure you want to change this practitioner's status?")) return;
            try {
                let practitioner = this.practitioners.find(p => p.id == id);
                await this.$api.patch(`/practitioners/${id}/toggle`);
                practitioner.user.is_active = !practitioner.user.is_active;
            } catch (error) {
                console.error("Error toggling status:", error);
            }
        },
    },
    mounted() {
        this.fetchPractitioners();
    },
};
</script>
